import { useEffect, useState } from 'react';
import { get_connections } from '../connections';
import { get_project_name } from '../../../../../../../utils/project';
import './PipelineSettings.css'
import { Back } from '../../../../../../../components/back/Back';

const PipeLineSettings = ({ projectId ,serviceName, setPipeline, next, back, data }) => {

    const [connections, setConnections] = useState([])
    const [settings, setSettings] = useState(Object.keys(data).length > 0 ? data : {
        pipeline_type: "",
        connector_id: 0,
        folder: "",
        name: serviceName,
        })
    
    useEffect(() => {
        get_connections(setConnections,"", "pipeline", projectId)
    }, []);

    useEffect(() => {
        if (connections.length != 0){
            setSettings({
                ...settings,
                connector_id: connections[0].id,
                pipeline_type: connections[0].connector_type
            });
        }
        if (settings.pipeline_type === "Jenkins") {
            get_project_name((projectName) => {
                if (Object.keys(data).length === 0) {
                    setSettings(prevSettings => ({
                        ...prevSettings,
                        folder: projectName
                    }));
                }
            }, projectId)
        }
    }, [connections]);
    return (
        <div className='pipeline-setting'>
            <Back back={()=>{setPipeline(settings); back()}}/>
            <h1>Pipeline Settings</h1>
                <div>
                    <div className='info-block'>
                        <label htmlFor="connector">Connector:</label>
                        <select
                            id="connector"
                            value={settings.connector_id}
                            onChange={(e) => {
                                const selectedId = parseInt(e.target.value);
                                const selectedConnection = connections.find(conn => conn.id === selectedId);
                        
                                if (selectedConnection) {
                                    setSettings({
                                        ...settings,
                                        connector_id: selectedConnection.id,
                                        pipeline_type: selectedConnection.connector_type
                                    });
                                }
                            }}
                        >
                            {connections.map((connection) => (
                                <option key={connection.id} value={connection.id}>
                                    {connection.name}
                                </option>
                            ))}
                        </select>
                    </div>
                </div>
                {settings.pipeline_type === "Jenkins" && (<div className='info-block'>
                    <label>Folder:</label>
                    <input type='text' value={settings.folder} 
                            onChange={(e)=>{setSettings({...settings, folder: e.target.value})}} />
                </div>)}
                <button className='next-button' onClick={()=>{setPipeline(settings);next()}}>next</button>
        </div>
    );
};

export default PipeLineSettings;